var dark = false;

if (
  window.matchMedia &&
  window.matchMedia("(prefers-color-scheme: dark)").matches
) {
  dark = true;
}
window
  .matchMedia("(prefers-color-scheme: dark)")
  .addEventListener("change", (e) => {
    dark = e.matches ? true : false;
  });

export default {
  darkmode: dark,
  gas: 3.99,
  initialGallons: 1.5,
  footer: () => "Telematics powered by Stealth Intelligence",
  mapCenter: { lat: 39.8283, lng: -98.5795 },  // Center of US — change to your location
};
